/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Myresourcelibrary2Inputs */

const zh_chat_myresourcelibrary2 = /** @type {(inputs: Chat_Myresourcelibrary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的资源库`)
};

const en_chat_myresourcelibrary2 = /** @type {(inputs: Chat_Myresourcelibrary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Resource Library`)
};

const es_chat_myresourcelibrary2 = /** @type {(inputs: Chat_Myresourcelibrary2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi Biblioteca de Recursos`)
};

/**
* | output |
* | --- |
* | "My Resource Library" |
*
* @param {Chat_Myresourcelibrary2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_myresourcelibrary2 = /** @type {((inputs?: Chat_Myresourcelibrary2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Myresourcelibrary2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_myresourcelibrary2(inputs)
	if (locale === "en") return en_chat_myresourcelibrary2(inputs)
	return es_chat_myresourcelibrary2(inputs)
});
export { chat_myresourcelibrary2 as "chat_myResourceLibrary" }